import Delta from 'quill-delta';

const parseHtmlToDelta = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const delta = new Delta();

  function parseNode(node) {
    // Text node
    if (node.nodeType === Node.TEXT_NODE) {
      return delta.insert(node.textContent);
    }

    // Element node
    if (node.nodeType === Node.ELEMENT_NODE) {
      const nodeName = node.nodeName.toLowerCase();

      // Handle empty paragraphs with just a br
      if (nodeName === 'p') {
        if (node.childNodes.length === 0 ||
          (node.childNodes.length === 1 && node.firstChild.nodeName.toLowerCase() === 'br')) {
          return delta.insert('\n');
        }

        // Parse children first
        Array.from(node.childNodes).forEach(child => {
          if (child.nodeName.toLowerCase() !== 'br') {
            parseNode(child);
          }
        });
        return delta.insert('\n');
      }

      if (nodeName === 'h1') {
        Array.from(node.childNodes).forEach(parseNode);
        return delta.insert('\n', { header: 1 });
      }

      if (nodeName === 'h2') {
        Array.from(node.childNodes).forEach(parseNode);
        return delta.insert('\n', { header: 2 });
      }

      // Only handle br if it's not inside an empty paragraph
      if (nodeName === 'br' && node.parentElement.nodeName.toLowerCase() !== 'p') {
        return delta.insert('\n');
      }

      // Handle inline formatting
      const formats = {};

      if (node.style.fontWeight === 'bold' || nodeName === 'strong' || nodeName === 'b') {
        formats.bold = true;
      }

      if (node.style.fontStyle === 'italic' || nodeName === 'em' || nodeName === 'i') {
        formats.italic = true;
      }

      if (nodeName === 'u' || node.style.textDecoration === 'underline') {
        formats.underline = true;
      }

      if (nodeName === 'a') {
        formats.link = node.getAttribute('href');
      }

      // Handle spans with classes (like mentions)
      if (nodeName === 'span' && node.className === 'mention') {
        return delta.insert({
          mention: {
            id: node.dataset.id,
            value: node.dataset.value,
            denotationChar: node.dataset.denotationChar,
            type: node.dataset.type,
          }
        });
      }

      // Parse children with current formats
      Array.from(node.childNodes).forEach(child => {
        if (Object.keys(formats).length > 0) {
          if (child.nodeType === Node.TEXT_NODE) {
            delta.insert(child.textContent, formats);
          } else {
            parseNode(child);
          }
        } else {
          parseNode(child);
        }
      });
    }
  }

  // Start parsing from body
  Array.from(doc.body.childNodes).forEach(parseNode);

  // Ensure the document ends with a newline
  if (!delta.ops[delta.ops.length - 1]?.insert?.endsWith('\n')) {
    delta.insert('\n');
  }

  return delta;
};

export default parseHtmlToDelta;
